function patchMediaGallery() {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;
  if (!gallery.setActiveMedia) {
    setTimeout(patchMediaGallery, 100);
    return;
  }

  const originalSetActiveMedia = gallery.setActiveMedia.bind(gallery);
  let blockUntil = Date.now() + 2000;

  gallery.setActiveMedia = function (mediaId, prepend) {
    if (prepend && Date.now() < blockUntil) return;
    originalSetActiveMedia(mediaId, prepend);
  };
}

document.addEventListener('DOMContentLoaded', patchMediaGallery);
